import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {CreateBeerStyleDto, GetBeerStylesDTO} from 'typescript/dto/beerStylesDto';
import ApiData from 'typescript/interfaces/ApiData';
import BeerStyle from 'typescript/models/BeerStyle';
import httpClient from 'utils/httpClient/httpClient';

export const getBeerStylesData = (search: GetBeerStylesDTO): Promise<AxiosResponse<ApiData<BeerStyle[]>>> => {
  const {per_page, page, name, order} = search;

  return httpClient.get(
    `${API.BEER_STYLES_SERVICE.BASE}?filter_sort[sort_direction]=${order}&filter_search[beer_style_name]=${name}&filter_sort[sort_column]=name&page=${page}&per_page=${per_page}`,
  );
};

export const createNewBeerStyle = (data: CreateBeerStyleDto): Promise<AxiosResponse<BeerStyle>> => {
  const requestData = {beer_style: data};

  return httpClient.post(API.BEER_STYLES_SERVICE.BASE, requestData);
};

export const beerStyleUpdate = (data: CreateBeerStyleDto, id: string): Promise<AxiosResponse<BeerStyle>> => {
  const requestData = {beer_style: data};

  return httpClient.put(`${API.BEER_STYLES_SERVICE.BASE}/${id}`, requestData);
};

export const getSingleBeerStyleData = (id: string): Promise<AxiosResponse<ApiData<BeerStyle>>> => {
  return httpClient.get(`${API.BEER_STYLES_SERVICE.BASE}/${id}`);
};
